/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from "theme-ui"
import React from "react"
import { Box, BoxProps } from "@shared-components/Box/Box"

export type ContainerProps = BoxProps & {
  withoutPaddingInline?: boolean
}

export const containerStyles: ThemeUIStyleObject = {
  width: "100%",
  maxWidth: "width.4",
  mx: "auto",
  px: [5, 6, 13],
}

export const containerStylesWithoutPadding: ThemeUIStyleObject = {
  width: "100%",
  maxWidth: "width.4",
  mx: "auto",
  px: 0,
}

const Container: React.FC<ContainerProps> = ({
  children,
  sx,
  withoutPaddingInline = false,
  ...props
}) => {
  return (
    <Box
      sx={{
        ...(withoutPaddingInline
          ? containerStylesWithoutPadding
          : containerStyles),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
}

Container.defaultProps = {}

export { Container }
